module.exports = __webpack_public_path__ + "img/card-profile1-square.3122abf4.jpg";